import { url } from '@/config';
import request from '../axios'
export const getList = (params) => request({
    url: url + '/category/list',
    method: 'get',
    params: params
});



export const getObj = (id) => request({
    url: url + '/category/detail',
    method: 'get',
    params: {
        id
    }
});

export const addObj = (data) => request({
    url: url + '/category/save',
    method: 'post',
    data: data
});
export const updateObj = (data) => request({
    url: url + '/category/update',
    method: 'post',
    data: data
});



export const delObj = (id) => request({
    url: url + '/category/remove',
    method: 'post',
    params: {
        ids: id
    }
});


// 定义一个函数，通过 GET 请求发送 token
export const getDataWithToken = (token) => request({
    url: `${process.env.VUE_APP_JEECG_API}`+'/alertmanager/verify', // 假设的端点
    method: 'post',
    params: {
        token // 将 token 作为 URL 参数发送
    }
});

// http://192.168.2.14:8088/jeecg-boot/alertmanager/verify
